// extracted by mini-css-extract-plugin
module.exports = {"dark":"Talking_dark__3UZ28","imageHolder":"Talking_imageHolder__24608","textContainer":"Talking_textContainer__1Dvim"};